import React from 'react';

import { useField } from 'react-final-form';
import styled from '@emotion/styled';
import { PrimaryButton } from '../Buttons';

const ButtonStyled = styled(PrimaryButton)`
  position: sticky;
  bottom: 8px;
  right: 0;
  align-self: flex-end;
  border: 1px solid ${({ theme }) => theme.colors.highlight};

  &:hover {
    border: 1px solid ${({ theme }) => theme.colors.highlight};
  }

  &:active {
    border: 1px solid ${({ theme }) => theme.colors.highlight};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    width: 100%;
  }
`;

interface NextButtonProps {
  hasValidationErrors: boolean;
  name: string;
}

const NextButton: React.FC<NextButtonProps> = ({
  hasValidationErrors,
  name,
}) => {
  const { input } = useField(name);

  const count = input.name && Array.isArray(input.value) && input.value?.length;

  if (hasValidationErrors) {
    return null;
  }

  return (
    <ButtonStyled type="submit">Далее {!!count && `(${count})`}</ButtonStyled>
  );
};

interface Props {
  isLastPage: boolean;
  submitting: boolean;
  name?: string;
  hasValidationErrors: boolean;
}

export const SubmitButton: React.FC<Props> = ({
  isLastPage,
  hasValidationErrors,
  submitting,
  name = '',
}) => {
  if (!isLastPage && !!name) {
    return <NextButton hasValidationErrors={hasValidationErrors} name={name} />;
  }

  return (
    <ButtonStyled type="submit" disabled={submitting}>
      Оформить запись
    </ButtonStyled>
  );
};
